// ../assets/data/data.js

import {
  web1,
  web2,
  web3,
  web4,
  health1,
  health2,
  music1,
  music2,
  person1,
  person2,
  person3,
  person4,
  caslav,
  vesna,
  milos,
} from "./images";

export const courses = {
  "matematika-ekonomski": {
    info: {
      title: "Matematika - Ekonomski",

      creator_name: "Časlav Pejdić",
    },
    details: {
      price_new: "140€",
    },

    description: {
      course_desc:
        "Kompletna priprema za kolokvijum i ispit. Postoji zbirka sa 500 rešenih ispitnih zadataka, kao i skripta sa teorijskim zadacima. Časovi mogu da se prate i uživo i online, a svi se snimaju, pa mogu i naknadno da se gledaju.",
    },

    creator: {
      creator_name: "Časlav Pejdić",
      creator_rating: "4.7",
      creator_skill: "dipl.ing.el & master ekonomije",
      creator_img: caslav,
      creator_desc: "Preko 20 godina iskustva u držanju časova studentima",
    },
  },
  "osnovi-ekonomije-ekonomski": {
    info: {
      title: "Osnovi Ekonomije - Ekonomski",

      creator_name: "Časlav Pejdić",
    },
    details: {
      price_new: "120€",
    },

    description: {
      course_desc:
        "Kompletna priprema za kolokvijum i ispit. Radimo i teoriju i zadatke. Prolazimo kroz sveže rokove.  Časovi mogu da se prate i uživo i online, a svi se snimaju, pa mogu i naknadno da se gledaju.",
    },

    creator: {
      creator_name: "Časlav Pejdić",
      creator_rating: "4.7",
      creator_skill: "dipl.ing.el & master ekonomije",
      creator_img: caslav,
      creator_desc: "Preko 20 godina iskustva u držanju časova studentima",
    },
  },
  "matematika-1-fon": {
    info: {
      title: "Matematika 1 - FON",

      creator_name: "Časlav Pejdić",
    },
    details: {
      price_new: "120€",
    },

    description: {
      course_desc:
        "Kompletna priprema za kolokvijume i ispit. Prolazimo kroz sveže rokove. Kurs je online i uplatom kursa se dobija pristup snimcima svih časova. Profesor je tu za sva pitanja.",
    },

    creator: {
      creator_name: "Časlav Pejdić",
      creator_rating: "4.7",
      creator_skill: "dipl.ing.el & master ekonomije",
      creator_img: caslav,
      creator_desc: "Preko 20 godina iskustva u držanju časova studentima",
    },
  },
  "matematika-2-fon": {
    info: {
      title: "Matematika 2 - FON",

      creator_name: "Časlav Pejdić",
    },
    details: {
      price_new: "120€",
    },

    description: {
      course_desc:
        "Kompletna priprema za kolokvijume i ispit. Prolazimo kroz sveže rokove. Kurs je online i uplatom kursa se dobija pristup snimcima svih časova. Profesor je tu za sva pitanja.",
    },

    creator: {
      creator_name: "Časlav Pejdić",
      creator_rating: "4.7",
      creator_skill: "dipl.ing.el & master ekonomije",
      creator_img: caslav,
      creator_desc: "Preko 20 godina iskustva u držanju časova studentima",
    },
  },
  "matematika-3-fon": {
    info: {
      title: "Matematika 3 - FON",

      creator_name: "Časlav Pejdić",
    },
    details: {
      price_new: "120€",
    },

    description: {
      course_desc:
        "Kompletna priprema za kolokvijume i ispit. Prolazimo kroz sveže rokove. Kurs je online i uplatom kursa se dobija pristup snimcima svih časova. Profesor je tu za sva pitanja.",
    },

    creator: {
      creator_name: "Časlav Pejdić",
      creator_rating: "4.7",
      creator_skill: "dipl.ing.el & master ekonomije",
      creator_img: caslav,
      creator_desc: "Preko 20 godina iskustva u držanju časova studentima",
    },
  },
  "matematika-1-saobracajni": {
    info: {
      title: "Matematika 1 - Saobraćajni",

      creator_name: "Časlav Pejdić",
    },
    details: {
      price_new: "120€",
    },

    description: {
      course_desc:
        "Kompletna priprema za kolokvijume i ispit. Prolazimo kroz sveže rokove. Kurs je online i uplatom kursa se dobija pristup snimcima svih časova. Profesor je tu za sva pitanja.",
    },

    creator: {
      creator_name: "Časlav Pejdić",
      creator_rating: "4.7",
      creator_skill: "dipl.ing.el & master ekonomije",
      creator_img: caslav,
      creator_desc: "Preko 20 godina iskustva u držanju časova studentima",
    },
  },
  "diskretna-matematika-ekonomski": {
    info: {
      title: "Diskretna Matematika - Ekonomski",

      creator_name: "Časlav Pejdić",
    },
    details: {
      price_new: "60€",
    },

    description: {
      course_desc:
        "Kompletna priprema za kolokvijum i ispit. Radimo i teoriju i zadatke. Prolazimo kroz sveže rokove.  Kurs je online i uplatom kursa se dobija pristup snimcima svih časova. Profesor je tu za sva pitanja.",
    },

    creator: {
      creator_name: "Časlav Pejdić",
      creator_rating: "4.7",
      creator_skill: "dipl.ing.el & master ekonomije",
      creator_img: caslav,
      creator_desc: "Preko 20 godina iskustva u držanju časova studentima",
    },
  },
  "statistika-ekonomski": {
    info: {
      title: "Statistika - Ekonomski",

      creator_name: "Časlav Pejdić",
    },
    details: {
      price_new: "120€",
    },

    description: {
      course_desc:
        "Kompletna priprema za kolokvijum i ispit. Radimo i teoriju i zadatke. Prolazimo kroz sveže rokove. Postoji skripta za teorijski deo. Časovi mogu da se prate i uživo i online, a svi se snimaju, pa mogu i naknadno da se gledaju.",
    },

    creator: {
      creator_name: "Časlav Pejdić",
      creator_rating: "4.7",
      creator_skill: "dipl.ing.el & master ekonomije",
      creator_img: caslav,
      creator_desc: "Preko 20 godina iskustva u držanju časova studentima",
    },
  },
  "mikroekonomija-ekonomski": {
    info: {
      title: "Mikroekonomija - Ekonomski",

      creator_name: "Časlav Pejdić",
    },
    details: {
      price_new: "160€",
    },

    description: {
      course_desc:
        "Radimo sva pitanja i zadatke iz Varijanove zbirke iz koje sve dolazi i na kolokvijumu i na ispitu. Časovi mogu da se prate i uživo i online, a svi se snimaju, pa mogu i naknadno da se gledaju.",
    },

    creator: {
      creator_name: "Časlav Pejdić",
      creator_rating: "4.7",
      creator_skill: "dipl.ing.el & master ekonomije",
      creator_img: caslav,
      creator_desc: "Preko 20 godina iskustva u držanju časova studentima",
    },
  },
  "osnovi-operacionih-istraživanja-ekonomski": {
    info: {
      title: "Osnovi operacionih istraživanja - Ekonomski",

      creator_name: "Vesna Lišanin",
    },
    details: {
      price_new: "100€",
    },

    description: {
      course_desc:
        "Kompletna priprema za kolokvijum i ispit. Radimo i teoriju i zadatke. Prolazimo kroz sveže rokove. Kurs je online i uplazom kursa se dobija pristup snimcima svih časova. Profesorka je tu za sva pitanja.",
    },

    creator: {
      creator_name: "Vesna Lišanin",
      creator_rating: "4.7",
      creator_skill: "profesor matematike",
      creator_img: vesna,
      creator_desc: "Preko 20 godina iskustva u držanju časova studentima",
    },
  },
  "upravljačko-računovodstvo-ekonomski": {
    info: {
      title: "Upravljačko računovodstvo - Ekonomski",

      creator_name: "Miloš Timotijević",
    },
    details: {
      price_new: "190€",
    },

    description: {
      course_desc:
        "Kompletna priprema za kolokvijum i ispit. Radimo i teoriju i zadatke. Prolazimo kroz sveže rokove. Časovi mogu da se prate i uživo i online.",
    },

    creator: {
      creator_name: "Miloš Timotijević",
      creator_rating: "4.7",
      creator_skill: "diplomirani ekonomista",
      creator_img: milos,
      creator_desc: "Preko 20 godina iskustva u držanju časova studentima",
    },
  },
  "linearna-algebra-ekonomski": {
    info: {
      title: "Linearna algebra - Ekonomski",

      creator_name: "Časlav Pejdić",
    },
    details: {
      price_new: "60€",
    },

    description: {
      course_desc:
        "Kompletna priprema za kolokvijum i ispit. Radimo i teoriju i zadatke. Prolazimo kroz sveže rokove.  Kurs je online i uplatom kursa se dobija pristup snimcima svih časova. Profesor je tu za sva pitanja.",
    },

    creator: {
      creator_name: "Časlav Pejdić",
      creator_rating: "4.7",
      creator_skill: "dipl.ing.el & master ekonomije",
      creator_img: caslav,
      creator_desc: "Preko 20 godina iskustva u držanju časova studentima",
    },
  },
  "teorija-verovatnoća-ekonomski": {
    info: {
      title: "Teorija verovatnoća - Ekonomski",

      creator_name: "Časlav Pejdić",
    },
    details: {
      price_new: "60€",
    },

    description: {
      course_desc:
        "Kompletna priprema za kolokvijum i ispit. Radimo i teoriju i zadatke. Prolazimo kroz sveže rokove.  Kurs je online i uplatom kursa se dobija pristup snimcima svih časova. Profesor je tu za sva pitanja.",
    },

    creator: {
      creator_name: "Časlav Pejdić",
      creator_rating: "4.7",
      creator_skill: "dipl.ing.el & master ekonomije",
      creator_img: caslav,
      creator_desc: "Preko 20 godina iskustva u držanju časova studentima",
    },
  },
  "finansijska-aktuarska-matematika-ekonomski": {
    info: {
      title: "Finansijska i aktuarska matematika - Ekonomski",

      creator_name: "Časlav Pejdić",
    },
    details: {
      price_new: "60€",
    },

    description: {
      course_desc:
        "Kompletna priprema za kolokvijum i ispit. Radimo i teoriju i zadatke. Prolazimo kroz sveže rokove.  Kurs je online i uplatom kursa se dobija pristup snimcima svih časova. Profesor je tu za sva pitanja.",
    },

    creator: {
      creator_name: "Časlav Pejdić",
      creator_rating: "4.7",
      creator_skill: "dipl.ing.el & master ekonomije",
      creator_img: caslav,
      creator_desc: "Preko 20 godina iskustva u držanju časova studentima",
    },
  },
  "teorija-odlučivanja-ekonomski": {
    info: {
      title: "Teorija odlučivanja - Ekonomski",

      creator_name: "Časlav Pejdić",
    },
    details: {
      price_new: "60€",
    },

    description: {
      course_desc:
        "Kompletna priprema za kolokvijum i ispit. Prolazimo kroz sveže rokove. Kurs je online i uplazom kursa se dobija pristup snimcima svih časova. Profesor je tu za sva pitanja.",
    },

    creator: {
      creator_name: "Časlav Pejdić",
      creator_rating: "4.7",
      creator_skill: "dipl.ing.el & master ekonomije",
      creator_img: caslav,
      creator_desc: "Preko 20 godina iskustva u držanju časova studentima",
    },
  },
  "teorijska-statistika-ekonomski": {
    info: {
      title: "Teorijska statistika - Ekonomski",

      creator_name: "Časlav Pejdić",
    },
    details: {
      price_new: "120€",
    },

    description: {
      course_desc:
        "Kompletna priprema za kolokvijum i ispit. Prolazimo kroz sveže rokove. Kurs je online i uplazom kursa se dobija pristup snimcima svih časova. Profesor je tu za sva pitanja.",
    },

    creator: {
      creator_name: "Časlav Pejdić",
      creator_rating: "4.7",
      creator_skill: "dipl.ing.el & master ekonomije",
      creator_img: caslav,
      creator_desc: "Preko 20 godina iskustva u držanju časova studentima",
    },
  },
  "ekonomska-statistika-ekonomski": {
    info: {
      title: "Ekonomska statistika - Ekonomski",

      creator_name: "Časlav Pejdić",
    },
    details: {
      price_new: "60€",
    },

    description: {
      course_desc:
        "Kompletna priprema za kolokvijum i ispit. Prolazimo kroz sveže rokove. Kurs je online i uplazom kursa se dobija pristup snimcima svih časova. Profesor je tu za sva pitanja.",
    },

    creator: {
      creator_name: "Časlav Pejdić",
      creator_rating: "4.7",
      creator_skill: "dipl.ing.el & master ekonomije",
      creator_img: caslav,
      creator_desc: "Preko 20 godina iskustva u držanju časova studentima",
    },
  },
  "racunovodstvo-troskova-ekonomski": {
    info: {
      title: "Računovodstvo troškova - Ekonomski",

      creator_name: "Aleksandra Popović",
    },
    details: {
      price_new: "10 000 din",
    },

    description: {
      course_desc:
        "Kompletna priprema za kolokvijum i ispit. Radimo i teoriju i zadatke. Prolazimo kroz sveže rokove. Časovi mogu da se prate isključivo online.",
    },

    creator: {
      creator_name: "Aleksandra Popović",
      creator_rating: "4.7",
      creator_skill: "diplomirani ekonomista",
      creator_img: person3,
      creator_desc: "Preko 20 godina iskustva u držanju časova studentima",
    },
  },
  "verovatnoća-fon": {
    info: {
      title: "Verovatnoća - FON",

      creator_name: "Časlav Pejdić",
    },
    details: {
      price_new: "120€",
    },

    description: {
      course_desc:
        "Kompletna priprema za kolokvijume i ispit. Prolazimo kroz sveže rokove. Kurs je online i uplatom kursa se dobija pristup snimcima svih časova. Profesor je tu za sva pitanja.",
    },

    creator: {
      creator_name: "Časlav Pejdić",
      creator_rating: "4.7",
      creator_skill: "dipl.ing.el & master ekonomije",
      creator_img: caslav,
      creator_desc: "Preko 20 godina iskustva u držanju časova studentima",
    },
  },
  "statistika-fon": {
    info: {
      title: "Statistika - FON",

      creator_name: "Časlav Pejdić",
    },
    details: {
      price_new: "120€",
    },

    description: {
      course_desc:
        "Kompletna priprema za kolokvijume i ispit. Prolazimo kroz sveže rokove. Kurs je online i uplatom kursa se dobija pristup snimcima svih časova. Profesor je tu za sva pitanja.",
    },

    creator: {
      creator_name: "Časlav Pejdić",
      creator_rating: "4.7",
      creator_skill: "dipl.ing.el & master ekonomije",
      creator_img: caslav,
      creator_desc: "Preko 20 godina iskustva u držanju časova studentima",
    },
  },
  "ekonomski-prijemni": {
    info: {
      title: "Ekonomski prijemni",

      creator_name: "Časlav Pejdić",
    },
    details: {
      price_new: "100€",
    },

    description: {
      course_desc:
        "Prolazimo kroz sve vrste zadataka koje mogu da se jave na prijemnom. Radimo primere prijemnih iz prethodnih godina. Časovi mogu da se prate i uživo i online, a svi se snimaju, pa mogu i naknadno da se pogledaju.",
    },

    creator: {
      creator_name: "Časlav Pejdić",
      creator_rating: "4.7",
      creator_skill: "dipl.ing.el & master ekonomije",
      creator_img: caslav,
      creator_desc: "Preko 20 godina iskustva u držanju časova studentima",
    },
  },
  "fon-prijemni": {
    info: {
      title: "FON prijemni",

      creator_name: "Časlav Pejdić",
    },
    details: {
      price_new: "200€",
    },

    description: {
      course_desc:
        "Prolazimo kroz sve vrste zadataka koje mogu da se jave na prijemnom. Radimo primere prijemnih iz prethodnih godina. Kurs je online i uplatom kursa se dobija pristup snimcima svih časova. Profesor je tu za sva pitanja.",
    },

    creator: {
      creator_name: "Časlav Pejdić",
      creator_rating: "4.7",
      creator_skill: "dipl.ing.el & master ekonomije",
      creator_img: caslav,
      creator_desc: "Preko 20 godina iskustva u držanju časova studentima",
    },
  },
  "finansijska-matematika-za-master-ekonomski": {
    info: {
      title: "Finansijska matematika za master - Ekonomski",

      creator_name: "Časlav Pejdić",
    },
    details: {
      price_new: "80€",
    },

    description: {
      course_desc:
        "Prolazimo sve materijale potrebne za ispit. Kurs je online i uplatom kursa se dobija pristup snimcima svih časova. Profesor je tu za sva pitanja",
    },

    creator: {
      creator_name: "Časlav Pejdić",
      creator_rating: "4.7",
      creator_skill: "dipl.ing.el & master ekonomije",
      creator_img: caslav,
      creator_desc: "Preko 20 godina iskustva u držanju časova studentima",
    },
  },
};
